import React, { useState } from "react";
import authentication from "../../images/authenticaion1.png";
import { ImArrowRight2 } from "react-icons/im";
import ScanCode from "./ScanCode";
import { Link, useLocation, useNavigate } from "react-router-dom";
const Login = () => {
  const [email, setEmail] = useState("");
  const [Otp, setOtp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const handleLogin = () => {
    if (email && Otp) {
      navigate(from, { replace: true });
    }
  };
  return (
    <div>
      <div className="grid lg:grid-cols-5  grid-cols-1 h-[calc(100vh-80px)] ">
        <div className="  flex flex-col col-span-2  justify-center items-center p-5 gap-5">
          <h2 className="text-black text-3xl font-bold ">Welcome back </h2>

          <div className="w-full  px-5 space-y-8 py-7">
            <div className="w-full space-y-5">
              <div className="form relative">
                <input
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  className="login-textbox "
                  placeholder=" "
                />
                <label htmlFor="" className="login-form-label">
                  Company Email
                </label>
              </div>
              <div className="form relative">
                <input
                  type="text"
                  onChange={(e) => setOtp(e.target.value)}
                  className="login-textbox "
                  placeholder=" "
                />
                <label htmlFor="" className="login-form-label">
                  OTP
                </label>
              </div>
            </div>

            <p className="text-black">Forget Password ?</p>

            <div className="flex justify-center items-center">
              {email && Otp ? (
                <button
                  onClick={handleLogin}
                  className=" lg:w-[330px] w-full h-[76px] bg-primary text-[22px] font-bold rounded text-white"
                >
                  Login
                </button>
              ) : (
                <button
                  disabled
                  className=" lg:w-[330px] w-full h-[76px] bg-primary bg-opacity-40  text-[22px] font-bold rounded text-white"
                >
                  Login
                </button>
              )}
            </div>
          </div>
          <ScanCode font={"text-black font-bold"} />
          <p className="font-semibold text-xl">
            Do not have an account?
            <span className="text-primary font-bold cursor-pointer">
              <Link to={"/create"}>Signup Here</Link>
            </span>
          </p>
        </div>
        <div className="bg-primary  flex flex-col  justify-center items-center text-white lg:px-10 col-span-3  gap-6 lg:p-10 p-3 text-center">
          <div>
            <h3 className="font-bold lg:text-[34px] text-xl mb-2">
              Tip of the day :
            </h3>
            <p className="lg:text-[30px] text-xl">
              Never share your wallet password with anyoune
            </p>
          </div>
          <img src={authentication} alt="" className="w-2/3" />
          <p className="lg:text-[24px] text-xl text-center">
            The weakeset link in security is the human factor. Never share your
            wallet passsword. Also, never login untrusted devices as the
            password might be save in keychain.
          </p>
          <p className="lg:text-[26px] text-xl font-bold flex justify-center items-center gap-2 cursor-pointer">
            <span> More on blog</span> <ImArrowRight2 />
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
